let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2OZrA")).then(() => parcelRequire('9c3LE'));